import logo from '../../assets/snb_ic.png';

export default function Header() {
    return (
        <div>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <img src={logo} className="Header-img" alt="" />
                </div>
            </div>

            <div className="row Mb-1">
                <div className="col-sm-12 col-md-12 col-lg-12 slogenText">
                    <h3>Save Money, Use SnB</h3>
                </div>
            </div>
        </div>
    );
}
